<template>
  <v-tab-container :title="title">
    <!-- Slot to add content at the level of the title -->
    <template #top>
      <!-- Show the date and creator user as a simple info at the level of the title -->
      <v-flex shrink>
        <v-layout align-center>
          <v-flex class="blue-grey--text font-weight-light mr-3" shrink>{{ createdString }}</v-flex>
          <!-- A button to remove the QMP -->
          <v-flex shrink>
            <v-confirmation-dialog
              @confirm="removeQmp"
              text="¿Estás seguro de eliminar por completo el QMP?"
            >
              <template #activator="{ on }">
                <v-btn v-on="on" color="red" dark :loading="loadingRemoveQmp">
                  <v-icon>clear</v-icon>
                  <span class="ml-2">Eliminar QMP</span>
                </v-btn>
              </template>
            </v-confirmation-dialog>
          </v-flex>
        </v-layout>
      </v-flex>
    </template>
    <!-- The QMIs of the QMP -->
    <v-flex v-for="(item, index) in qmp.items" :key="index" xs12 sm4 md3 lg2 class="pa-2">
      <v-item-card :item="item" hide-header vertical xs>
        <!-- Add a button to remove the QMI from the QMP -->
        <v-layout justify-center>
          <v-flex shrink>
            <v-confirmation-dialog
              @confirm="removeQmiFromQmp(index)"
              text="¿Estás seguro de eliminar este QMI del QMP?"
            >
              <template #activator="{ on }">
                <v-btn v-on="on" color="red" dark round small>
                  <v-icon small>clear</v-icon>
                  <span class="ml-2">Eliminar</span>
                </v-btn>
              </template>
            </v-confirmation-dialog>
          </v-flex>
        </v-layout>
      </v-item-card>
    </v-flex>
  </v-tab-container>
</template>

<script>
import Vue from "vue";
import { createNamespacedHelpers } from "vuex";

const { mapActions } = createNamespacedHelpers("matching");

import VConfirmationDialog from "@/components/confirmations/ConfirmationDialog.vue";
import VItemCard from "../../components/ItemCard";
import VTabContainer from "../../components/TabContainer";

export default {
  components: {
    VConfirmationDialog,
    VItemCard,
    VTabContainer
  },
  props: {
    qmp: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      loadingRemoveQmp: false,
      loadingRemoveQmiFromQmp: this.qmp.items.map(() => false)
    };
  },
  computed: {
    brand() {
      return this.$route.params.brandName;
    },
    classificationId() {
      return this.$route.params.classificationId;
    },
    createdString() {
      let string = `Creado el ${new Date(this.qmp.created).toLocaleString()}`;

      if (this.qmp.creatorUser) {
        string += ` por ${this.qmp.creatorUser}`;
      }

      return string;
    },
    title() {
      return `QMatchProductId ${this.qmp.id}`;
    }
  },
  methods: {
    ...mapActions({
      removeQmiFromQmpAction: "removeQmiFromQmp",
      removeQmpAction: "removeQmp"
    }),
    ...mapActions(["getQmps"]),
    async removeQmiFromQmp(index) {
      const { sellerId, historyId } = this.qmp.items[index];
      Vue.set(this.loadingRemoveQmiFromQmp, index, true);
      await this.removeQmiFromQmpAction({
        qmpId: this.qmp.id,
        sellerId,
        historyId
      });
      this.loadingRemoveQmiFromQmp.splice(index, 1);
    },
    async removeQmp() {
      this.loadingRemoveQmp = true;
      await this.removeQmpAction({ qmpId: this.qmp.id });
      this.loadingRemoveQmp = false;
      return this.getQmps({
        brand: this.brand,
        classificationId: this.classificationId
      });
    }
  }
};
</script>